module.exports = __webpack_public_path__ + "static/media/yelp.86fc5c52.png";